import { useAtom } from "jotai";
import { savedFiltersAtom } from "./atoms";
import { keysFromSavedRows } from "../../utils/accessibilitySelection";

export function useSavedFilters() {
  const [{ data, isLoading, isFetching, error, refetch }] =
    useAtom(savedFiltersAtom);
  const rows =
    data?.accessibility_preferences[0]?.user_accessibility_preferences || [];
  return {
    savedFilters: data,
    isLoading,
    isFetching,
    isSavedFiltersLoading: isLoading || isFetching,
    error,
    loadSavedFilters: refetch,
    // A tag saved in two sections is two rows; callers that only know tags see it once.
    savedFilterIds: Array.from(new Set(rows.map((pref) => pref.tag_id))),
    savedFilterKeys: keysFromSavedRows(rows),
  };
}
